module.exports = __webpack_public_path__ + "img/payment.7d2d62ad.svg";